// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.estimation__tabs {
  padding: 16px 0;
}
.estimation__tabs .pui-tabs__header-tab span {
  font-weight: bold;
}
.estimation__tabs__headline {
  width: fit-content;
  color: #0476D9;
  font-weight: bold;
  padding-bottom: 8px;
  border-bottom: 3px solid #0476D9;
}
.estimation__tabs__content {
  margin-top: 16px;
}
.estimation__empty-estimation-error {
  min-height: 150px;
}
.estimation__empty-estimation-error .pui-loader-error__message {
  font-size: 16px;
  color: #adadad;
}
.estimation__action-button {
  display: flex;
  justify-content: center;
}
.estimation__headline {
  margin-bottom: 8px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
